// src/components/SMSContacts.js

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BrandButton, TextCancelButton } from "../button";
import {
  Typography,
  Box,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Pagination,
  Backdrop,
  CircularProgress,
  Grid,
  LinearProgress,
} from "@mui/material";
import {
  acme,
  acmePageSectionCardSx,
  acmeBillingSectionContentSx,
} from "../../theme/acmeTheme";
import {
  PageShell,
  PageHeader,
  Card,
  CardContent,
  Table,
  Dialog,
  Button as AcmeButton,
  Menu,
  MenuItem as AcmeMenuItem,
  TableEmptyRow,
  TableActionsMenu,
  TableActionsMenuButton,
  destructiveMenuItemSx,
  stopTableRowClick,
} from "../ui";
import PageBlockTitle, { PageBlockHeader } from "../ui/PageBlockTitle";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import GroupsIcon from "@mui/icons-material/Groups";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import PageSnackbars from "../common/PageSnackbars";
import { usePageSnackbar } from "../common/usePageSnackbar";
import { isEndUserRole } from "../../utils/userRoles";
import {
  formatPhonesForImport,
  parsePhonesFromFile,
  parsePhonesFromText,
  readImportFile,
} from "../../utils/smsContactImport";

const CATEGORIES = [
  "Construction",
  "IT",
  "Recruiting",
  "Marketing",
  "Finance",
  "Healthcare",
  "Education",
  "Manufacturing",
  "Retail",
  "Hospitality",
  "Transportation",
  "Telecommunications",
  "Energy",
  "Consulting",
  "Other",
];

const rowsPerPage = 50;

const splitPhoneInput = (value) =>
  String(value || "")
    .split(/[\n,;]+/)
    .map((phone) => phone.trim())
    .filter(Boolean);

const SMSContacts = () => {
  const { groupName } = useParams();
  const navigate = useNavigate();
  const { setSuccessMessage, setErrorMessage, snackbarProps } =
    usePageSnackbar();
  const [userRole, setUserRole] = useState(null);
  const canManageStatus = !isEndUserRole(userRole);

  // ????????? ??? ?????? ?????
  const [groups, setGroups] = useState([]);

  // ??????? ??? ?????
  const [groupNameFilter, setGroupNameFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [groupsPage, setGroupsPage] = useState(0);
  const [groupsRowsPerPage, setGroupsRowsPerPage] = useState(20);

  // ??????? ???????? ??????
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [newGroupName, setNewGroupName] = useState("");
  const [newGroupCategory, setNewGroupCategory] = useState("");

  // ?????? ???????? ??????
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState({
    open: false,
    groupId: null,
  });
  const [contactsMenuAnchor, setContactsMenuAnchor] = useState(null);
  const [groupRowMenu, setGroupRowMenu] = useState({ anchorEl: null, group: null });
  const [contactRowMenu, setContactRowMenu] = useState({ anchorEl: null, contact: null });
  const [renameGroupDialog, setRenameGroupDialog] = useState({
    open: false,
    currentName: "",
    newName: "",
  });
  const [renamingGroup, setRenamingGroup] = useState(false);

  // ????????? ??? ??????? ?????
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [importedContacts, setImportedContacts] = useState([]);
  const [importGroupName, setImportGroupName] = useState("");
  const [importCategory, setImportCategory] = useState("");
  const [customImportCategory, setCustomImportCategory] = useState("");
  const [customNewGroupCategory, setCustomNewGroupCategory] = useState("");
  const [importMethodDialog, setImportMethodDialog] = useState(false);
  const [importType, setImportType] = useState("");
  const [pasteImportDialog, setPasteImportDialog] = useState(false);
  const [pasteData, setPasteData] = useState("");
  const [importProgress, setImportProgress] = useState(0);
  const [importMessage, setImportMessage] = useState("");
  const [showProgress, setShowProgress] = useState(false);

  // ????????? ??? ????????? ???????? (?????????)
  const [contacts, setContacts] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState({ phone: "", status: "" });
  const [page, setPage] = useState(1);

  // ?????? ?????????? ???????
  const [openAddPhoneDialog, setOpenAddPhoneDialog] = useState(false);
  const [newPhones, setNewPhones] = useState("");

  // ?????? ??????? ? ???????????? ??????
  const [openImportGroupDialog, setOpenImportGroupDialog] = useState(false);
  const [importedGroupContacts, setImportedGroupContacts] = useState([]);

  // ????????? ????????
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const [loadingAddPhones, setLoadingAddPhones] = useState(false);
  const [loadingImport, setLoadingImport] = useState(false);

  // ???????? ?????? ?????
  const fetchGroups = async () => {
    setLoadingGroups(true);
    try {
      const response = await axios.get("/api/sms-contacts/groups");
      setGroups(response.data);
    } catch (error) {
      console.error("Failed to fetch SMS groups:", error.message);
      setErrorMessage(
        `Failed to fetch groups: ${error.response?.data?.error || error.message}`,
      );
    } finally {
      setLoadingGroups(false);
    }
  };

  // ???????? ???????? (????????) ??? ?????????? ??????
  const fetchContacts = async () => {
    setLoadingContacts(true);
    try {
      const response = await axios.get(
        `/api/sms-contacts?groupId=${encodeURIComponent(groupName)}`,
      );
      setContacts(response.data);
    } catch (error) {
      console.error("Failed to fetch SMS contacts:", error);
      setErrorMessage(
        `Failed to fetch contacts: ${error.response?.data?.error || error.message}`,
      );
    } finally {
      setLoadingContacts(false);
    }
  };

  // ?????????????
  useEffect(() => {
    const getUserRole = async () => {
      try {
        const response = await axios.get("/api/auth/check-session");
        if (response.data?.user) {
          setUserRole(response.data.user.role);
        }
      } catch (error) {
        console.error("Failed to get user role:", error);
      }
    };
    getUserRole();
  }, []);

  useEffect(() => {
    if (!groupName) {
      // ???? ??? groupName ? URL � ?????????? ?????? ?????
      fetchGroups();
    } else {
      // ???? ???? groupName ? URL � ?????????? ???????? ???? ??????
      setSearch("");
      setFilter({ phone: "", status: "" });
      setPage(1);
      fetchContacts();
    }
    // Intentional: refetch when route group changes; omit unstable fetch fns
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupName]);

  const resetFileInput = (inputId) => {
    const el = document.getElementById(inputId);
    if (el) el.value = "";
  };

  const openPhonesImportPreview = (phones, type) => {
    const unique = [...new Set(phones)];
    if (unique.length === 0) {
      setErrorMessage("No valid phone numbers found.");
      return;
    }
    const asContacts = unique.map((phone) => ({ phone }));
    if (type === "groups") {
      setImportedContacts(asContacts);
      setOpenImportDialog(true);
    } else {
      setImportedGroupContacts(asContacts);
      setOpenImportGroupDialog(true);
    }
  };

  const processImportFile = async (file, type) => {
    try {
      const data = await readImportFile(file);
      const phones = parsePhonesFromFile(file, data);
      openPhonesImportPreview(phones, type);
    } catch (error) {
      console.error("Error reading file:", error);
      setErrorMessage("Error reading file. Please check the file format.");
    }
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    await processImportFile(file, "groups");
    resetFileInput("file-input-sms-groups");
  };

  const handleFileSelectGroupImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    await processImportFile(file, "contacts");
    resetFileInput("file-input-sms-contacts");
  };

  const handleImportMethodSelect = (method, type) => {
    setImportType(type);
    setImportMethodDialog(false);
    if (method === "file") {
      const id =
        type === "groups" ? "file-input-sms-groups" : "file-input-sms-contacts";
      document.getElementById(id)?.click();
    } else if (method === "paste") {
      setPasteImportDialog(true);
    }
  };

  const handlePasteImport = () => {
    if (!pasteData.trim()) {
      setErrorMessage("Please paste some phone numbers to import.");
      return;
    }
    const phones = parsePhonesFromText(pasteData);
    openPhonesImportPreview(phones, importType);
    setPasteImportDialog(false);
    setPasteData("");
  };

  const handleImportSubmit = async () => {
    setLoadingImport(true);
    const finalCategory =
      importCategory === "Other" ? customImportCategory : importCategory;

    if (!importGroupName?.trim() || !finalCategory?.trim()) {
      setErrorMessage("Please specify group name and category.");
      setLoadingImport(false);
      return;
    }
    if (importedContacts.length === 0) {
      setErrorMessage("No contacts to import.");
      setLoadingImport(false);
      return;
    }

    const formattedPhones = [
      ...new Set(formatPhonesForImport(importedContacts)),
    ];
    if (formattedPhones.length === 0) {
      setErrorMessage("No valid phone numbers found after processing.");
      setLoadingImport(false);
      return;
    }

    setShowProgress(true);
    setImportProgress(10);
    setImportMessage(`Importing ${formattedPhones.length} phone numbers…`);

    try {
      const { data } = await axios.post(
        "/api/sms-contacts/import",
        {
          phones: formattedPhones,
          group: importGroupName.trim(),
          category: finalCategory.trim(),
        },
        { timeout: 300000 },
      );
      setOpenImportDialog(false);
      setImportedContacts([]);
      setImportGroupName("");
      setImportCategory("");
      setCustomImportCategory("");
      setShowProgress(false);
      setImportProgress(0);
      setImportMessage("");
      setSuccessMessage(
        `Import complete: ${data.upserted ?? 0} added, ${data.modified ?? 0} updated, ${data.invalidCount ?? 0} invalid skipped.`,
      );
      setGroupNameFilter("");
      setCategoryFilter("");
      await fetchGroups();
    } catch (error) {
      console.error("Failed to import contacts:", error);
      setShowProgress(false);
      setImportProgress(0);
      setImportMessage("");
      if (error.code === "ECONNABORTED") {
        setErrorMessage(
          "Import timed out. Try a smaller file or split the list.",
        );
      } else {
        setErrorMessage(
          error.response?.data?.error ||
            error.response?.data?.message ||
            "Failed to import contacts. Please try again.",
        );
      }
    } finally {
      setLoadingImport(false);
    }
  };

  // ???????? ??????
  const handleCreateGroup = async () => {
    setLoadingGroups(true);
    const finalCategory =
      newGroupCategory === "Other" ? customNewGroupCategory : newGroupCategory;

    if (!newGroupName.trim() || !finalCategory?.trim()) {
      setErrorMessage("Please enter a valid group name and category.");
      setLoadingGroups(false);
      return;
    }
    try {
      const { data } = await axios.post("/api/sms-contacts/groups", {
        name: newGroupName.trim(),
        category: finalCategory.trim(),
      });
      setOpenCreateDialog(false);
      setNewGroupName("");
      setNewGroupCategory("");
      setCustomNewGroupCategory("");
      setSuccessMessage(
        data?.alreadyExists
          ? "Group already exists."
          : "Group created successfully.",
      );
      setGroupNameFilter("");
      setCategoryFilter("");
      await fetchGroups();
    } catch (error) {
      console.error("Failed to create group:", error);
      setErrorMessage(error.response?.data?.error || "Failed to create group.");
    } finally {
      setLoadingGroups(false);
    }
  };

  // ???????? ??????
  const handleDeleteGroup = async () => {
    if (!confirmDeleteDialog.groupId) return;
    setLoadingGroups(true);
    try {
      await axios.delete(
        `/api/sms-contacts/groups/${encodeURIComponent(confirmDeleteDialog.groupId.trim())}`,
      );
      setConfirmDeleteDialog({ open: false, groupId: null });
      await fetchGroups();
    } catch (error) {
      console.error("Failed to delete group", error);
      setErrorMessage("Failed to delete group.");
    } finally {
      setLoadingGroups(false);
    }
  };

  const openRenameGroupDialog = (currentName) => {
    setRenameGroupDialog({
      open: true,
      currentName,
      newName: currentName,
    });
  };

  const closeRenameGroupDialog = () => {
    setRenameGroupDialog({ open: false, currentName: "", newName: "" });
  };

  const handleRenameGroup = async () => {
    const trimmedNewName = renameGroupDialog.newName.trim();
    const currentName = renameGroupDialog.currentName.trim();

    if (!trimmedNewName) {
      setErrorMessage("Group name is required.");
      return;
    }
    if (trimmedNewName === currentName) {
      setErrorMessage("New name must be different from the current name.");
      return;
    }

    setRenamingGroup(true);
    try {
      await axios.put(
        `/api/sms-contacts/groups/${encodeURIComponent(currentName)}/rename`,
        { newName: trimmedNewName },
      );
      setSuccessMessage(`Group renamed to "${trimmedNewName}".`);
      closeRenameGroupDialog();

      if (groupName && groupName === currentName) {
        navigate(`/sms/contacts/${encodeURIComponent(trimmedNewName)}`);
      } else {
        await fetchGroups();
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.error || "Failed to rename group.");
    } finally {
      setRenamingGroup(false);
    }
  };

  const openGroupRowMenu = (event, group) => {
    event.stopPropagation();
    setGroupRowMenu({ anchorEl: event.currentTarget, group });
  };

  const closeGroupRowMenu = () => {
    setGroupRowMenu({ anchorEl: null, group: null });
  };

  const handleGroupRowMenuItem = (action) => {
    const group = groupRowMenu.group;
    if (!group) return;
    closeGroupRowMenu();

    if (action === "rename") {
      openRenameGroupDialog(group.groupName);
      return;
    }
    if (action === "delete") {
      setConfirmDeleteDialog({
        open: true,
        groupId: group.groupName,
      });
    }
  };

  const openContactRowMenu = (event, contact) => {
    event.stopPropagation();
    setContactRowMenu({ anchorEl: event.currentTarget, contact });
  };

  const closeContactRowMenu = () => {
    setContactRowMenu({ anchorEl: null, contact: null });
  };

  const handleContactRowMenuItem = (action) => {
    const contact = contactRowMenu.contact;
    if (!contact) return;
    closeContactRowMenu();

    if (action === "rename") {
      openRenameGroupDialog(groupName);
      return;
    }
    if (action === "delete") {
      handleDeleteContact(contact._id);
    }
  };

  // ???????? ????????
  const handleDeleteContact = async (id) => {
    try {
      await axios.delete(`/api/sms-contacts/${id}`);
      fetchContacts();
    } catch (error) {
      console.error("Failed to delete contact:", error);
    }
  };

  // ?????????? ?????????
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };
  const handleFilterChange = (e) => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.value,
    });
  };
  const filteredContacts = contacts.filter(
    (contact) =>
      (contact.phone || contact.e164 || "").includes(search) &&
      (filter.phone
        ? (contact.phone || contact.e164 || "").includes(filter.phone)
        : true) &&
      (filter.status ? contact.status === filter.status : true),
  );
  const paginatedContacts = filteredContacts.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage,
  );

  // ?????????? ???????
  const updateContactStatus = async (id, newStatus) => {
    try {
      await axios.put(`/api/sms-contacts/${id}/status`, { status: newStatus });
      setContacts((prev) =>
        prev.map((contact) =>
          contact._id === id ? { ...contact, status: newStatus } : contact,
        ),
      );
      setSuccessMessage("Status updated successfully.");
    } catch (error) {
      console.error("Failed to update contact status:", error);
      setErrorMessage("Failed to update contact status.");
    }
  };

  // ?????????? ??????? ???????
  const handleAddPhones = async () => {
    setLoadingAddPhones(true);
    const phonesArray = splitPhoneInput(newPhones);
    if (phonesArray.length === 0) {
      setErrorMessage("Please enter at least one valid phone number.");
      setLoadingAddPhones(false);
      return;
    }
    try {
      const { data } = await axios.post("/api/sms-contacts/groups/add-phones", {
        groupName,
        phones: phonesArray,
      });
      setSuccessMessage(
        `Phones processed: ${data.upserted ?? 0} added, ${data.modified ?? 0} updated, ${data.invalidCount ?? 0} invalid skipped.`,
      );
      setOpenAddPhoneDialog(false);
      setNewPhones("");
      setSearch("");
      setFilter({ phone: "", status: "" });
      setPage(1);
      await fetchContacts();
    } catch (error) {
      console.error("Failed to add phones:", error);
      setErrorMessage(error.response?.data?.error || "Failed to add phones.");
    } finally {
      setLoadingAddPhones(false);
    }
  };

  const handleImportGroupSubmit = async () => {
    setLoadingImport(true);
    if (importedGroupContacts.length === 0) {
      setErrorMessage("No contacts to import.");
      setLoadingImport(false);
      return;
    }

    const phones = [...new Set(formatPhonesForImport(importedGroupContacts))];
    if (phones.length === 0) {
      setErrorMessage("No valid phone numbers found after processing.");
      setLoadingImport(false);
      return;
    }

    setShowProgress(true);
    setImportProgress(10);
    setImportMessage(
      `Starting import of ${phones.length} numbers into group "${groupName}"…`,
    );

    try {
      const { data } = await axios.post(
        "/api/sms-contacts/groups/add-phones",
        { groupName, phones },
        { timeout: 300000 },
      );
      setOpenImportGroupDialog(false);
      setImportedGroupContacts([]);
      setShowProgress(false);
      setImportProgress(100);
      setImportMessage("");
      setSuccessMessage(
        `Import complete: ${data.upserted ?? 0} added, ${data.modified ?? 0} updated, ${data.invalidCount ?? 0} invalid skipped.`,
      );
      setSearch("");
      setFilter({ phone: "", status: "" });
      setPage(1);
      await fetchContacts();
    } catch (error) {
      console.error("Failed to import contacts:", error);
      setShowProgress(false);
      setImportProgress(0);
      setImportMessage("");
      if (error.code === "ECONNABORTED") {
        setErrorMessage(
          "Import timed out. Try a smaller file or split the list.",
        );
      } else {
        setErrorMessage(
          error.response?.data?.error ||
            error.response?.data?.message ||
            "Failed to import contacts.",
        );
      }
    } finally {
      setLoadingImport(false);
    }
  };

  // ?????????? ?????
  useEffect(() => {
    applyGroupFilters();
    // Intentional: sync filtered list when groups/filters change; applyGroupFilters recreated each render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groups, groupNameFilter, categoryFilter]);

  const applyGroupFilters = () => {
    let tempGroups = [...groups];
    if (groupNameFilter.trim() !== "") {
      tempGroups = tempGroups.filter((g) =>
        g.groupName.toLowerCase().includes(groupNameFilter.toLowerCase()),
      );
    }
    if (categoryFilter.trim() !== "") {
      tempGroups = tempGroups.filter((g) => g.category === categoryFilter);
    }
    setFilteredGroups(tempGroups);
    setGroupsPage(0);
  };

  const paginatedGroups = filteredGroups.slice(
    groupsPage * groupsRowsPerPage,
    groupsPage * groupsRowsPerPage + groupsRowsPerPage,
  );

  // ???? groupName ?? ?????? => ???????? ?????? ?????
  const renderGroupsUI = () => (
    <Card sx={{ ...acmePageSectionCardSx, boxShadow: 'none', mt: 0 }}>
      <CardContent sx={acmeBillingSectionContentSx}>
        <PageBlockHeader>
          <PageBlockTitle>Contact Groups</PageBlockTitle>
          <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
            <AcmeButton
              variant="default"
              startIcon={<AddIcon />}
              onClick={() => setOpenCreateDialog(true)}
              disabled={loadingGroups}
            >
              New Group
            </AcmeButton>
            <AcmeButton
              variant="outline"
              startIcon={<CloudUploadIcon />}
              onClick={() => {
                setImportType("groups");
                setImportMethodDialog(true);
              }}
              disabled={loadingGroups}
            >
              Import Contacts
            </AcmeButton>
            <input
              id="file-input-sms-groups"
              type="file"
              accept=".xlsx, .xls, .csv, .txt"
              hidden
              onChange={handleFileSelect}
            />
          </Box>
        </PageBlockHeader>
        {loadingGroups ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="200px"
          >
            <CircularProgress />
          </Box>
        ) : (
          <Table containerSx={{ mt: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell>Group Name</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Number of Phones</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <TextField
                    value={groupNameFilter}
                    onChange={(e) => setGroupNameFilter(e.target.value)}
                    placeholder="Filter by Group Name"
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <Select
                    value={categoryFilter}
                    onChange={(e) => setCategoryFilter(e.target.value)}
                    displayEmpty
                    variant="outlined"
                    size="small"
                    fullWidth
                  >
                    <MenuItem value="">All Categories</MenuItem>
                    {CATEGORIES.map((cat) => (
                      <MenuItem key={cat} value={cat}>
                        {cat}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>
                <TableCell />
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedGroups.length > 0 ? (
                paginatedGroups.map((group) => (
                  <TableRow
                    key={group.groupName}
                    onClick={() =>
                      navigate(
                        `/sms/contacts/${encodeURIComponent(group.groupName)}`,
                      )
                    }
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: acme.colors.muted,
                      },
                    }}
                  >
                    <TableCell>{group.groupName}</TableCell>
                    <TableCell>{group.category}</TableCell>
                    <TableCell>
                      <span>{group.totalCount} </span>(
                      <span style={{ color: acme.colors.brand }}>
                        {group.subscribedCount}
                      </span>{" "}
                      /
                      <span style={{ color: acme.colors.destructive }}>
                        {group.unsubscribedCount}
                      </span>
                      )
                    </TableCell>
                    <TableCell onClick={stopTableRowClick}>
                      <TableActionsMenuButton
                        ariaLabel="Group actions"
                        onClick={(event) => openGroupRowMenu(event, group)}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableEmptyRow
                  colSpan={4}
                  icon={GroupsIcon}
                  title="No SMS contact groups yet"
                  description="Create a group to organize phone numbers for SMS campaigns, or import contacts from a file."
                  hint='Click "New Group" or "Import Contacts" above to get started.'
                />
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={filteredGroups.length}
                  page={groupsPage}
                  onPageChange={(event, newPage) => setGroupsPage(newPage)}
                  rowsPerPage={groupsRowsPerPage}
                  onRowsPerPageChange={(event) => {
                    const newVal = parseInt(event.target.value, 10);
                    setGroupsRowsPerPage(newVal);
                    setGroupsPage(0);
                  }}
                  rowsPerPageOptions={[20, 50, 100, 200, 500]}
                  labelRowsPerPage="Rows per page"
                  colSpan={4}
                />
              </TableRow>
            </TableFooter>
          </Table>
        )}

        {/* ?????? ???????? ?????? */}
        <Dialog
          open={openCreateDialog}
          onClose={() => setOpenCreateDialog(false)}
        >
          <DialogTitle>Create New SMS Group</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              margin="dense"
              label="Group Name"
              value={newGroupName}
              onChange={(e) => setNewGroupName(e.target.value)}
            />
            <Select
              fullWidth
              value={newGroupCategory}
              onChange={(e) => setNewGroupCategory(e.target.value)}
              displayEmpty
              style={{ marginTop: "15px" }}
            >
              <MenuItem value="" disabled>
                Select Category
              </MenuItem>
              {CATEGORIES.map((cat) => (
                <MenuItem key={cat} value={cat}>
                  {cat}
                </MenuItem>
              ))}
            </Select>
            {newGroupCategory === "Other" && (
              <TextField
                fullWidth
                margin="dense"
                label="Custom category"
                value={customNewGroupCategory}
                onChange={(e) => setCustomNewGroupCategory(e.target.value)}
              />
            )}
          </DialogContent>
          <DialogActions>
            <TextCancelButton
              onClick={() => setOpenCreateDialog(false)}
              disabled={loadingGroups}
            >
              Cancel
            </TextCancelButton>
            <BrandButton onClick={handleCreateGroup} disabled={loadingGroups}>
              {loadingGroups ? <CircularProgress size={24} /> : "Create"}
            </BrandButton>
          </DialogActions>
        </Dialog>

        {/* ?????? ??????? ????? */}
        <Dialog
          open={openImportDialog}
          onClose={() => setOpenImportDialog(false)}
        >
          <DialogTitle>Import Phone Contacts</DialogTitle>
          <DialogContent>
            <Typography sx={{ mb: 2 }}>
              You are about to import {importedContacts.length} phone number
              {importedContacts.length === 1 ? "" : "s"} into a new group.
            </Typography>
            {showProgress && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {importMessage}
                </Typography>
                <LinearProgress
                  variant={
                    importProgress >= 100 ? "determinate" : "indeterminate"
                  }
                  value={importProgress}
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: acme.colors.brand,
                    },
                  }}
                />
              </Box>
            )}
            <TextField
              fullWidth
              margin="dense"
              label="Group Name"
              value={importGroupName}
              onChange={(e) => setImportGroupName(e.target.value)}
            />
            <Select
              fullWidth
              value={importCategory}
              onChange={(e) => setImportCategory(e.target.value)}
              displayEmpty
              style={{ marginTop: "15px" }}
            >
              <MenuItem value="" disabled>
                Select Category
              </MenuItem>
              {CATEGORIES.map((cat) => (
                <MenuItem key={cat} value={cat}>
                  {cat}
                </MenuItem>
              ))}
            </Select>
            {importCategory === "Other" && (
              <TextField
                fullWidth
                margin="dense"
                label="Custom category"
                value={customImportCategory}
                onChange={(e) => setCustomImportCategory(e.target.value)}
              />
            )}
          </DialogContent>
          <DialogActions>
            <TextCancelButton
              onClick={() => setOpenImportDialog(false)}
              disabled={loadingImport}
            >
              Cancel
            </TextCancelButton>
            <BrandButton onClick={handleImportSubmit} disabled={loadingImport}>
              {loadingImport ? <CircularProgress size={24} /> : "Add Contacts"}
            </BrandButton>
          </DialogActions>
        </Dialog>

        {/* ?????? ????????????? ???????? ?????? */}
        <Dialog
          open={confirmDeleteDialog.open}
          onClose={() => setConfirmDeleteDialog({ open: false, groupId: null })}
        >
          <DialogTitle>Delete Group</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this group?</Typography>
          </DialogContent>
          <DialogActions>
            <TextCancelButton
              onClick={() =>
                setConfirmDeleteDialog({ open: false, groupId: null })
              }
              disabled={loadingGroups}
            >
              Cancel
            </TextCancelButton>
            <BrandButton onClick={handleDeleteGroup} disabled={loadingGroups}>
              {loadingGroups ? <CircularProgress size={24} /> : "Delete"}
            </BrandButton>
          </DialogActions>
        </Dialog>
      </CardContent>
    </Card>
  );

  // ???? groupName ?????? => ???????? ????????
  const renderContactsUI = () => (
    <Card sx={{ ...acmePageSectionCardSx, boxShadow: 'none', mt: 0 }}>
      <CardContent sx={acmeBillingSectionContentSx}>
        <PageBlockHeader>
          <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
            <AcmeButton
              variant="outline"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate("/sms/contacts")}
            >
              Back to Groups
            </AcmeButton>
            <PageBlockTitle>Contacts in group: {groupName}</PageBlockTitle>
          </Box>
          <Box display="flex" gap={1} alignItems="center">
            <AcmeButton
              variant="default"
              startIcon={<AddIcon />}
              onClick={() => setOpenAddPhoneDialog(true)}
              disabled={loadingContacts}
            >
              New Contact
            </AcmeButton>
            <TableActionsMenuButton
              ariaLabel="More actions"
              onClick={(e) => setContactsMenuAnchor(e.currentTarget)}
            />
            <Menu
              anchorEl={contactsMenuAnchor}
              open={Boolean(contactsMenuAnchor)}
              onClose={() => setContactsMenuAnchor(null)}
            >
              <AcmeMenuItem
                onClick={() => {
                  setContactsMenuAnchor(null);
                  setImportType("contacts");
                  setImportMethodDialog(true);
                }}
              >
                <CloudUploadIcon
                  fontSize="small"
                  sx={{ mr: 1.5, color: acme.colors.iconDefault }}
                />
                Import Contacts
              </AcmeMenuItem>
            </Menu>
            <input
              id="file-input-sms-contacts"
              type="file"
              accept=".xlsx, .xls, .csv, .txt"
              hidden
              onChange={handleFileSelectGroupImport}
            />
          </Box>
        </PageBlockHeader>
        <Box mb={2} display="flex">
          <TextField
            label="Search Phone"
            value={search}
            onChange={handleSearchChange}
            fullWidth
          />
        </Box>
        {loadingContacts ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="200px"
          >
            <CircularProgress />
          </Box>
        ) : (
          <Table containerSx={{ mt: 0 }}>
            <TableHead>
              <TableRow>
                <TableCell>Phone</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <TextField
                    name="phone"
                    label="Filter by Phone"
                    value={filter.phone}
                    onChange={handleFilterChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <Select
                    name="status"
                    label="Filter by Status"
                    value={filter.status}
                    onChange={handleFilterChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="subscribed">Subscribed</MenuItem>
                    <MenuItem value="unsubscribed">Unsubscribed</MenuItem>
                  </Select>
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedContacts.map((contact) => (
                <TableRow key={contact._id}>
                  <TableCell>{contact.phone || contact.e164}</TableCell>
                  <TableCell>
                    <Select
                      value={contact.status}
                      onChange={(e) =>
                        updateContactStatus(contact._id, e.target.value)
                      }
                      size="small"
                      disabled={!canManageStatus}
                      style={{
                        color:
                          contact.status === "unsubscribed" ? "red" : "black",
                        fontWeight:
                          contact.status === "unsubscribed" ? "bold" : "normal",
                        opacity: !canManageStatus ? 0.7 : 1,
                      }}
                    >
                      <MenuItem value="subscribed">Subscribed</MenuItem>
                      <MenuItem value="unsubscribed">Unsubscribed</MenuItem>
                    </Select>
                  </TableCell>
                  <TableCell onClick={stopTableRowClick}>
                    <TableActionsMenuButton
                      ariaLabel="Contact actions"
                      onClick={(event) => openContactRowMenu(event, contact)}
                    />
                  </TableCell>
                </TableRow>
              ))}
              {paginatedContacts.length === 0 && (
                <TableEmptyRow
                  colSpan={3}
                  icon={PhoneAndroidIcon}
                  title="No contacts in this group"
                  description="Add phone numbers manually or import them to start sending SMS campaigns to this group."
                  hint='Click "New Contact" or use the menu to import contacts.'
                />
              )}
            </TableBody>
          </Table>
        )}
        <Box mt={2} display="flex" justifyContent="center">
          <Pagination
            count={Math.ceil(filteredContacts.length / rowsPerPage)}
            page={page}
            onChange={(e, value) => setPage(value)}
          />
        </Box>
        {/* ?????? ?????????? ??????? ??????? */}
        <Dialog
          open={openAddPhoneDialog}
          onClose={() => setOpenAddPhoneDialog(false)}
        >
          <DialogTitle>Add Phones to Group</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              margin="dense"
              label="Phones (comma or line separated)"
              value={newPhones}
              onChange={(e) => setNewPhones(e.target.value)}
              placeholder="+37256321309, +37254640621"
            />
          </DialogContent>
          <DialogActions>
            <TextCancelButton
              onClick={() => setOpenAddPhoneDialog(false)}
              disabled={loadingAddPhones}
            >
              Cancel
            </TextCancelButton>
            <BrandButton onClick={handleAddPhones} disabled={loadingAddPhones}>
              {loadingAddPhones ? <CircularProgress size={24} /> : "Add"}
            </BrandButton>
          </DialogActions>
        </Dialog>

        {/* ?????? ??????? ? ???????????? ?????? */}
        <Dialog
          open={openImportGroupDialog}
          onClose={() => setOpenImportGroupDialog(false)}
        >
          <DialogTitle>Import Contacts to Group</DialogTitle>
          <DialogContent>
            <Typography sx={{ mb: 2 }}>
              You are about to import {importedGroupContacts.length} phone
              number
              {importedGroupContacts.length === 1 ? "" : "s"} into group &quot;
              {groupName}
              &quot;.
            </Typography>
            {showProgress && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {importMessage}
                </Typography>
                <LinearProgress
                  variant={
                    importProgress >= 100 ? "determinate" : "indeterminate"
                  }
                  value={importProgress}
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: acme.colors.brand,
                    },
                  }}
                />
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <TextCancelButton
              onClick={() => setOpenImportGroupDialog(false)}
              disabled={loadingImport}
            >
              Cancel
            </TextCancelButton>
            <BrandButton
              onClick={handleImportGroupSubmit}
              disabled={loadingImport}
            >
              {loadingImport ? <CircularProgress size={24} /> : "Import"}
            </BrandButton>
          </DialogActions>
        </Dialog>
      </CardContent>
    </Card>
  );

  const importMethodDialogUi = (
    <Dialog
      open={importMethodDialog}
      onClose={() => setImportMethodDialog(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ textAlign: "center", pb: 2 }}>
        Choose Import Method
      </DialogTitle>
      <DialogContent sx={{ px: 4, pb: 4 }}>
        <Typography
          variant="body2"
          sx={{ textAlign: "center", mb: 4, color: "#666" }}
        >
          Select how you would like to import phone numbers
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                p: 3,
                textAlign: "center",
                cursor: "pointer",
                border: "2px solid transparent",
                "&:hover": {
                  border: `2px solid ${acme.colors.foreground}`,
                  backgroundColor: "#f8f9fa",
                },
                height: "100%",
              }}
              onClick={() => handleImportMethodSelect("file", importType)}
            >
              <CloudUploadIcon
                sx={{ fontSize: 48, color: acme.colors.foreground, mb: 2 }}
              />
              <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                Upload File
              </Typography>
              <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
                Import from Excel, CSV, or TXT (first column = phone)
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: acme.colors.mutedForegroundSolid }}
              >
                Supports: .xlsx, .xls, .csv, .txt
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                p: 3,
                textAlign: "center",
                cursor: "pointer",
                border: "2px solid transparent",
                "&:hover": {
                  border: `2px solid ${acme.colors.foreground}`,
                  backgroundColor: "#f8f9fa",
                },
                height: "100%",
              }}
              onClick={() => handleImportMethodSelect("paste", importType)}
            >
              <ContentPasteIcon
                sx={{ fontSize: 48, color: acme.colors.foreground, mb: 2 }}
              />
              <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                Copy &amp; Paste
              </Typography>
              <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
                Paste numbers from clipboard (with country code)
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: acme.colors.mutedForegroundSolid }}
              >
                Separate with commas, semicolons, or new lines
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 4, pb: 3 }}>
        <TextCancelButton onClick={() => setImportMethodDialog(false)}>
          Cancel
        </TextCancelButton>
      </DialogActions>
    </Dialog>
  );

  const pasteImportDialogUi = (
    <Dialog
      open={pasteImportDialog}
      onClose={() => setPasteImportDialog(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Paste Phone Numbers</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2, color: "#666" }}>
          Paste numbers below. Include country code (e.g. +491701234567). You
          can separate them with commas, semicolons, or new lines.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={10}
          variant="outlined"
          label="Paste phone numbers here"
          placeholder={"+491701111111, +442222222222"}
          value={pasteData}
          onChange={(e) => setPasteData(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <TextCancelButton onClick={() => setPasteImportDialog(false)}>
          Cancel
        </TextCancelButton>
        <BrandButton primaryHover="light" onClick={handlePasteImport}>
          Import Contacts
        </BrandButton>
      </DialogActions>
    </Dialog>
  );

  return (
    <PageShell>
      <PageHeader
        title={groupName ? groupName : 'Contact Groups'}
        description={
          groupName
            ? 'View and manage phone contacts in this group. Add numbers manually or import from a file.'
            : 'Organize phone numbers into groups for SMS campaigns, or import contacts from a file.'
        }
        sx={{ mb: 2 }}
      />
      {showProgress && importMessage && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            backgroundColor: "white",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            p: 2,
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: "bold", mb: 1 }}
          >
            {importMessage}
          </Typography>
          <LinearProgress
            variant={importProgress >= 100 ? "determinate" : "indeterminate"}
            value={importProgress}
            sx={{
              height: 10,
              borderRadius: 5,
              "& .MuiLinearProgress-bar": {
                backgroundColor: acme.colors.brand,
              },
            }}
          />
        </Box>
      )}

      {groupName ? renderContactsUI() : renderGroupsUI()}

      {importMethodDialogUi}
      {pasteImportDialogUi}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={
          loadingGroups || loadingContacts || loadingAddPhones || loadingImport
        }
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <PageSnackbars {...snackbarProps} />

      <TableActionsMenu
        anchorEl={groupRowMenu.anchorEl}
        open={Boolean(groupRowMenu.anchorEl)}
        onClose={closeGroupRowMenu}
      >
        <AcmeMenuItem onClick={() => handleGroupRowMenuItem("rename")}>
          Rename
        </AcmeMenuItem>
        <AcmeMenuItem
          onClick={() => handleGroupRowMenuItem("delete")}
          sx={destructiveMenuItemSx}
        >
          Delete
        </AcmeMenuItem>
      </TableActionsMenu>

      <TableActionsMenu
        anchorEl={contactRowMenu.anchorEl}
        open={Boolean(contactRowMenu.anchorEl)}
        onClose={closeContactRowMenu}
      >
        <AcmeMenuItem onClick={() => handleContactRowMenuItem("rename")}>
          Rename
        </AcmeMenuItem>
        <AcmeMenuItem
          onClick={() => handleContactRowMenuItem("delete")}
          sx={destructiveMenuItemSx}
        >
          Delete
        </AcmeMenuItem>
      </TableActionsMenu>

      <Dialog open={renameGroupDialog.open} onClose={closeRenameGroupDialog}>
        <DialogTitle>Rename Group</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label="Group Name"
            value={renameGroupDialog.newName}
            onChange={(e) =>
              setRenameGroupDialog((prev) => ({ ...prev, newName: e.target.value }))
            }
          />
        </DialogContent>
        <DialogActions>
          <TextCancelButton onClick={closeRenameGroupDialog} disabled={renamingGroup}>
            Cancel
          </TextCancelButton>
          <BrandButton onClick={handleRenameGroup} disabled={renamingGroup}>
            {renamingGroup ? <CircularProgress size={24} /> : "Rename"}
          </BrandButton>
        </DialogActions>
      </Dialog>
    </PageShell>
  );
};

export default SMSContacts;
